import {
  ApolloClient,
  InMemoryCache,
  split,
  ApolloLink,
  Observable,
} from "@apollo/client";
import { HttpLink } from "@apollo/client/link/http";
import { getMainDefinition } from "@apollo/client/utilities";
import { createClient } from 'graphql-ws';
import {getCookie} from "@/helpers";
const token  = getCookie('accessToken')
const dashboardUrlEnv = process.env.VUE_APP_DASHBOARD_URL  // || 'https://account.stage.ad-firm.com/api/v2/graphql';
console.log(`UrlEnv ${dashboardUrlEnv}`)
const hostname = window.location.hostname;
const generateStageURL = (url) => {
  return url.replace('//account.', '//account.stage.');
};
// TODO add this logic to Dockerfile
const stageDashboardUrl = generateStageURL(dashboardUrlEnv);

let dashboardUrl = (hostname.includes("stage")) ? stageDashboardUrl : dashboardUrlEnv;

if (hostname.includes("backoffice.kprnt.com")){
  dashboardUrl = 'https://account.kprnt.com/api/v2/graphql';
  console.log(`DASHBOARD_URL_GOTZHA: ${dashboardUrl} hostname:${hostname}` );
} else if (hostname.includes("backoffice.stage.kprnt.com")) {
  dashboardUrl = 'https://account.stage.kprnt.com/api/v2/graphql';
  console.log(`DASHBOARD_URL_GOTZHA_STAGE: ${dashboardUrl} hostname:${hostname}` );
} else {
  console.log(`DASHBOARD_URL: ${dashboardUrl} hostname:${hostname}` );
}
const isHttps = dashboardUrl.startsWith('https://');
const webSocketProtocol = isHttps ? 'wss://' : 'ws://';
const host = dashboardUrl.split('/')[2];
const webSocketUrl = webSocketProtocol + host + '/api/subscriptions';

console.log(`DASHBOARD_URL webSocketUrl: ${webSocketUrl}` );

const httpLink = new HttpLink({
  uri: dashboardUrl,
  headers: {
    token: token,
    source: 'back-office-app'
  },
});


console.log('DASHBOARD_URL webSocketUrl : ', webSocketUrl);
// Create a WebSocket client
const wsClient = createClient({
  url: webSocketUrl,
  connectionParams: {
    token: token,
    source: 'back-office-app'
  },
});

const wsLink = new ApolloLink((operation) =>
  new Observable((observer) => {
    const unsubscribe = wsClient.subscribe(
      { ...operation, query: operation.query.loc?.source.body },
      {
        next: observer.next.bind(observer),
        error: observer.error.bind(observer),
        complete: observer.complete.bind(observer),
      }
    );
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  })
);

const link = split(
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === "OperationDefinition" && operation === "subscription";
  },
  wsLink,
  httpLink
);

const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

export { apolloClient };
